import { Component } from '@angular/core';

import { MessengerSmsComponent } from '../messages/messenger/messenger.sms.component';

@Component({
  selector   : 'bookings-request-send-sms',
  template: require('./bookings.request.send-sms.component.html')
})
export class BookingsRequestSendSmsComponent extends MessengerSmsComponent {}
